import dayjs from "dayjs";
import { isInternetExplorer } from "../client/util";

export function todayInSydney() {
  if (isInternetExplorer()) {
    // IE 11 Does not support toLocaleString with timeZone option. Use best guess option
    const d = new Date();
    d.setHours(d.getUTCHours() + 11);
    return dayjs(d);
  } else {
    return dayjs(new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" }));
  }
}
